import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

export const useClickOutside = (
  onClick: (event?: MouseEvent) => void,
  deps: any[] = []
): RefObject<HTMLDivElement> => {
  const node: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);

  const handleClick = (event: MouseEvent): void => {
    const { current } = node;
    if (!current || current.contains(event.target as Node)) {
      return;
    }
    onClick(event);
  };

  useEffect(() => {
    document.removeEventListener('mousedown', handleClick);
    document.addEventListener('mousedown', handleClick);
    return (): void => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, deps);

  return node;
};
